import { render } from "./edit-member.vue?vue&type=template&id=a0ec845a&scoped=true"
import script from "./edit-member.vue?vue&type=script&lang=js"
export * from "./edit-member.vue?vue&type=script&lang=js"

import "./edit-member.vue?vue&type=style&index=0&id=a0ec845a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0ec845a"]])

export default __exports__